import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { ColorPallet } from "../../utils/colorPallet";
import AppButton from "../common/AppButton";
import ReturnItemIcon from "../IconComp/returnItemIcon";
import AppModal from "../common/AppModal";
import { ReturnInvoiceModal } from "./return-invoice-model";
import { getInvoiceData } from "../../features/invoice/invoiceSlice";
import { useAppDispatch } from "../../app/hooks";
import { format } from "date-fns";
import { AddReturnSales } from "../../features/sales/salesSlice";
import AppSnackbar from "../common/AppSnackbar";
import { useSelector } from "react-redux";
import { ProductReturnHeader } from "../../utils/constants";

const ReturnMedicine = () => {
  const [invoiceNumber, setInvoiceNumber] = useState<any>("");
  const [returnDate, setReturnDate] = useState<any>("2024-04-20");
  const [purchasedItem, setPurchasedItems] = useState<any>([]);
  const [oneTimeRet, setOneTimeRet] = useState<any>([]);
  const [returnItem, setReturnItem] = useState<any>([]);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [discountAmountSingle, setDiscountAmountSingle] = useState<any>();
  const [discountPercSingle, setDiscountPercSingle] = useState<any>();
  const [discountPercentage, setDiscountPercentage] = useState<any>();
  const [selectedIndex, setSelectedIndex] = useState<any>(null);
  const [discountedAmount, setDiscountedAmount] = useState(0);
  const [discountedAmountSingle, setDiscountedAmountSingle] = useState<any>([]);
  const [discountedAmountSinglePayload, setDiscountedAmountSinglePayload] =
    useState(0);
  const handleOpenInvoiceModal = () => setOpenInvoiceModal(true);
  const handleCloseInvoiceModal = () => setOpenInvoiceModal(false);
  const dispatch = useAppDispatch();
  const pharmacyId = localStorage?.getItem("pharmacyId") || "";
  const { staff_id } = useSelector((state: any) => state?.staff);
  const staff_data = localStorage.getItem("staff_data");
  const StaffData = staff_data ? JSON.parse(staff_data) : null;
  const Id = staff_id || StaffData?.id;

  const handleReturn = (index: any, returnedQuantity: number) => {
    const updatedItems = [...purchasedItem];
    const item = updatedItems[index];

    // Check if returned quantity is not entered or is zero
    if (!item?.returnedQuantity) {
      alert("Enter Returned Medicine quantity.");
      return;
    }
    if (item?.returnedQuantity < 0) {
      alert("Medicine quantity must be greater then zero.");
      return;
    }

    item.returned = true;
    item.returnedQuantity = returnedQuantity;
    item.remainingQuantity = item?.quantity - returnedQuantity;
    item.remainingAmount = item?.returnedQuantity * item?.rate;

    setPurchasedItems(updatedItems);

    // Add returned item to returnItem array with medicine name
    setReturnItem((prevReturnItems: any) => [
      ...prevReturnItems,
      {
        batch_id: item?.batchId,
        sales_id: item?.salesId,
        medicine_name: item?.medicineName, // Add medicine name
        quantity_to_be_returned: item?.returnedQuantity,
        amount_to_be_return: item?.remainingAmount,
        rate: item?.rate,
        discountedAmt: item?.amountAfterDis,
        discountAmountSingle: item?.discountAmt,
        discountPercSingle: item?.discountPerc,
        totalQuantity: item?.quantity,
        dose: item?.med_dose,
      },
    ]);
  };

  const handleUndo = (index: any) => {
    const updatedItems = [...purchasedItem];
    const item = updatedItems[index];

    item.returned = false;
    item.returnedQuantity = 0;
    item.remainingQuantity = item?.quantity;
    item.remainingAmount = item?.amount;

    setPurchasedItems(updatedItems);
    setReturnItem((prevReturnItems: any) =>
      prevReturnItems.filter(
        (returnedItem: any) => returnedItem?.sales_id !== item?.salesId
      )
    );
  };

  const handleGenerateInvoice = () => {
    handleOpenInvoiceModal();
  };
  const currentFormattedDate = format(new Date(), "dd-MM-yyyy");

  const handleCellFocus = (index: number) => {
    setSelectedIndex(index);
  };
  const handleChange = (index: number, value: string) => {
    if (value > purchasedItem[index]?.quantity) {
      alert("Quantity returned should be less than or equal to Quantity Sold");
      return;
    }
    const updatedItems = [...purchasedItem];
    updatedItems[index].returnedQuantity = value || 0;
    setPurchasedItems(updatedItems);
  };
  const handleCellBlur = (index: number) => {
    const updatedItems = [...purchasedItem];
    const item = updatedItems[index];
    item.returnedQuantity = item?.returnedQuantity || 0;
    setPurchasedItems(updatedItems);
    setSelectedIndex(null);
  };
  const handleKeyPress = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Enter") {
      handleCellBlur(index);
    }
  };

  const getInvoice = useCallback(async () => {
    if (invoiceNumber) {
      const obj: any = {
        pharmacy_id: pharmacyId,
        invoice_id: invoiceNumber,
      };

      try {
        const res: any = await dispatch(getInvoiceData(obj));
        if (res?.payload) {
          setOneTimeRet(res?.payload);
          const salesData = res?.payload?.sales?.map((sale: any) => ({
            batchNumber: sale?.batch?.batch_no,
            batchId: sale?.batch?.id,
            medicineName: sale?.medicine_name,
            med_dose: sale?.batch?.pharmacy_medicine?.dose,
            quantity: sale?.quantity_sold,
            rate: sale?.sell_price,
            amount: sale?.amount_to_be_paid,
            amountAfterDis: sale?.amount_after_discount,
            discountAmt: sale?.discount_amount,
            discountPerc: sale?.discount_percentage,
            salesId: sale?.id,
            returned: false,
            isEditable: false,
          }));
          setPurchasedItems(salesData);
          setDiscountPercentage(res?.payload?.discount_percentage);
        }
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    }
  }, [dispatch, invoiceNumber, pharmacyId]);

  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  // Calculate discounted amount whenever returnItem or discountPercentage changes
  useEffect(() => {
    const totalAmountToBeReturned = returnItem?.reduce(
      (total: number, item: any) => total + item?.amount_to_be_return,
      0
    );

    const discountAmount =
      (totalAmountToBeReturned * (parseFloat(discountPercentage) || 0)) / 100;
    setDiscountedAmount(discountAmount);
  }, [returnItem, discountPercentage]);

  useEffect(() => {
    if (returnItem && returnItem.length > 0) {
      const updatedDiscounts = returnItem?.map((item: any) => {
        const totalAmountToBeReturned = item?.discountedAmt || 0;
        const totalDiscountAmountSingle = item?.discountAmountSingle || 0;
        const totalQuantityReturned = item?.totalQuantity || 1; // Ensure quantity is not 0

        // Calculate per item discounts
        const discountAmount =
          totalDiscountAmountSingle / totalQuantityReturned;
        const discountedAmount =
          totalAmountToBeReturned / totalQuantityReturned;

        // Return calculated values for each medicine
        return {
          discountAmount,
          discountedAmount,
        };
      });

      // Assuming you're storing the values separately in an array or object
      setDiscountAmountSingle(
        updatedDiscounts?.map((item: any) => item?.discountAmount)
      );
      setDiscountedAmountSingle(
        updatedDiscounts?.map((item: any) => item?.discountedAmount)
      );

      // Calculate total discount percentage for all items
      const totalDiscPer = returnItem?.reduce(
        (total: number, item: any) =>
          total + (item?.discountPercSingle || 0) / returnItem?.length,
        0
      );
      setDiscountPercSingle(totalDiscPer);
    }
  }, [returnItem, discountPercentage]);

  // const hasDiscountPercentagePrevious = returnItem?.some(
  //   (entry: any) => entry?.discountPercSingle
  // );

  const hasDiscountPercentagePrevious = returnItem?.some(
    (entry: any) => entry?.discountPercSingle != null
  );

  useEffect(() => {
    if (Array.isArray(discountAmountSingle) && Array.isArray(returnItem)) {
      // Ensure both arrays are of the same length to avoid mismatch
      const totalDiscountedAmount = discountAmountSingle.reduce(
        (acc: number, amount: number, index: number) =>
          acc + amount * returnItem[index]?.quantity_to_be_returned || 0,
        0
      );

      setDiscountedAmountSinglePayload(totalDiscountedAmount);
    } else {
      console.error("discountAmountSingle or returnItem is not an array");
    }
  }, [discountAmountSingle, returnItem]); // Only re-run when discountAmountSingle or returnItem changes

  const handleSubmit = async () => {
    const pharmacyId = localStorage?.getItem("pharmacyId");
    // Calculate the total amount to be returned
    const totalAmountToBeReturned = returnItem?.reduce(
      (total: number, item: any) => total + item?.amount_to_be_return,
      0
    );

    // Calculate the amount after applying the discount
    const amountAfterDiscount = totalAmountToBeReturned - discountedAmount;

    const amountAfterDiscountSing =
      totalAmountToBeReturned - discountedAmountSinglePayload;

    const returnSalesPayload: any = {
      pharmacy_id: pharmacyId,
      return_by: parseInt(Id),
      return_by_admin: Id ? false : true,
      med_returned_amount: hasDiscountPercentagePrevious
        ? amountAfterDiscountSing
        : amountAfterDiscount,
      invoice_id: invoiceNumber,
      staff_id: Id,
      discount_percentage: hasDiscountPercentagePrevious
        ? parseFloat(discountPercSingle) || 0
        : parseFloat(discountPercentage) || 0,
      discount_amount: hasDiscountPercentagePrevious
        ? discountedAmountSinglePayload
        : discountedAmount || 0,

      returnSalesArray: returnItem?.map((item: any) => ({
        batch_id: item?.batch_id,
        sales_id: item?.sales_id,
        quantity_to_be_returned: item?.quantity_to_be_returned,
        amount_to_be_return: item?.amount_to_be_return,
        return_discount_amount:
          (item?.discountAmountSingle / item?.totalQuantity) *
          item?.quantity_to_be_returned,
        return_discount_percentage: item?.discountPercSingle,
      })),
    };

    try {
      const res = await dispatch(AddReturnSales(returnSalesPayload));

      if (res.payload.success === true) {
        setPurchasedItems([]);
        setReturnItem([]);
        setInvoiceNumber("");
        setOpenSnackbar(true);
      } else {
        window.alert("Failed to add sales. Please try again.");
      }
    } catch (error) {
      console.error("Error adding sales: ", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Box sx={{ display: "flex", mb: 2, flexDirection: "row", gap: 2 }}>
          <Box sx={{ width: "50%" }}>
            <Typography variant="h6" gutterBottom>
              Reference Invoice #
            </Typography>
            <TextField
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
              fullWidth
              sx={{ "& .MuiInputBase-root": { height: "40px" } }}
              inputProps={{
                placeholder: "Enter the original invoice#",
              }}
            />
          </Box>
          <Box sx={{ width: "50%" }}>
            <Typography variant="h6" gutterBottom>
              Return Invoice Date
            </Typography>
            <TextField
              value={currentFormattedDate}
              disabled={true}
              fullWidth
              sx={{ "& .MuiInputBase-root": { height: "40px" } }}
              inputProps={{
                placeholder: "Enter the original invoice#",
              }}
            />
          </Box>
        </Box>

        {oneTimeRet?.is_return ? (
          <Typography
            variant="h6"
            sx={{
              mt: 5,
              backgroundColor: "#FDF5F5",
              padding: "8px",
              px: 2,
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            An invoice can only be returned once. This invoice has already been
            returned.
          </Typography>
        ) : (
          <>
            <Typography
              variant="h6"
              sx={{
                backgroundColor: "#1A202C",
                color: "#fff",
                padding: "8px",
                px: 2,
                fontSize: "16px",
              }}
            >
              Purchased Items List
            </Typography>
            <Box
              sx={{
                width: "100%",
                mb: 3,
                maxHeight: {
                  xs: 300,
                  sm: 400,
                  xl: 700,
                },
                overflowY: "auto",
                overflowX: "auto",
                minWidth: { xs: "100%", sm: "600px" },
              }}
            >
              <Table
                sx={{ width: "100%", minWidth: 650, overflowX: "auto" }}
                stickyHeader
              >
                <TableHead sx={{ backgroundColor: "#F0F1F5" }}>
                  <TableRow>
                    {ProductReturnHeader.map((item: any) => (
                      <TableCell
                        sx={{
                          border: `1px solid ${ColorPallet.borderColor}`,
                          paddingY: "2px !important",
                          paddingLeft: "8px !important",
                        }}
                      >
                        {item.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {purchasedItem?.length > 0 ? (
                    purchasedItem?.map((item: any, index: any) => {
                      if (item?.quantity === 0) return null;
                      return (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              textDecoration: item?.returned
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.batchNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              textDecoration: item?.returned
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.medicineName}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              textDecoration: item?.returned
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.quantity}
                          </TableCell>
                          <TableCell
                            onClick={() => handleCellFocus(index)}
                            sx={{
                              cursor: "editable",
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              padding: 0,
                            }}
                          >
                            {selectedIndex === index ? (
                              <TextField
                                type="number"
                                value={item.returnedQuantity}
                                onChange={(e) =>
                                  handleChange(index, e.target.value)
                                }
                                onBlur={() => handleCellBlur(index)}
                                onKeyPress={(e) => handleKeyPress(e, index)}
                                fullWidth
                                sx={{
                                  "& .MuiInputBase-root": { height: "40px" },
                                }}
                              />
                            ) : (
                              <Typography sx={{ px: "16px" }}>
                                {item?.returnedQuantity || 0}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              textDecoration: item?.returned
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.rate}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "2px !important",
                              paddingLeft: "8px !important",
                              textDecoration: item?.returned
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.amount}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: `1px solid ${ColorPallet.borderColor}`,
                              paddingY: "4px !important",
                              paddingLeft: "8px !important",
                              padding: 0,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              {item?.returned ? (
                                <Button
                                  onClick={() => handleUndo(index)}
                                  variant="outlined"
                                  color="primary"
                                  sx={{
                                    minWidth: "102px",
                                    height: "24px",
                                    textTransform: "none",
                                    border: "1px solid #0055A8",
                                  }}
                                >
                                  Undo
                                </Button>
                              ) : (
                                <Button
                                  onClick={() =>
                                    handleReturn(
                                      index,
                                      item?.returnedQuantity || 0
                                    )
                                  }
                                  variant="contained"
                                  sx={{
                                    minWidth: "101px",
                                    height: "24px",
                                    textTransform: "none",
                                    bgcolor: "#F0483E",
                                  }}
                                  startIcon={<ReturnItemIcon />}
                                >
                                  Return
                                </Button>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="center"
                        style={{
                          height: "20vh",
                        }}
                      >
                        No Data Found!
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <AppButton
                variant="contained"
                color="primary"
                title="Generate Invoice"
                sx={{ float: "right", textTransform: "none" }}
                onClick={handleGenerateInvoice}
                disabled={
                  purchasedItem?.length === 0 || purchasedItem === undefined
                }
              />
            </Box>
          </>
        )}
      </Box>
      <AppModal
        title="Invoice Details"
        open={openInvoiceModal}
        handleClose={handleCloseInvoiceModal}
        fullScreen={false}
        maxWidth="sm"
        //maxWidth="md"
        // maxWidth={"10%"}
      >
        <ReturnInvoiceModal
          onClose={handleCloseInvoiceModal}
          invoiceId={invoiceNumber}
          purchasedItem={purchasedItem}
          returnItem={returnItem}
          handleSubmit={handleSubmit}
          discountedAmount={discountedAmount}
          discountedAmountSingle={discountedAmountSingle}
          discountAmountSingle={discountAmountSingle}
        />
      </AppModal>
      <AppSnackbar
        message="Return Medicine Successfully!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

export default ReturnMedicine;
